import { useTranslation } from 'helpers/hooks/useTranslation'
import React from 'react'
import styled from 'styled-components'
import Icon, { IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import { complementaryColor } from 'uiComponents/constants/colors'
import { fsXXXXS, fwHeavy } from 'uiComponents/constants/typography'

export const StyledScrollDownButton = styled.button`
  cursor: pointer;
  padding: 10px 0;
  align-self: center;
  margin: 0 auto 8px;
  text-align: center;
  width: 100px;
  z-index: 1;
`

const ScrollText = styled.div`
  color: ${complementaryColor};
  font-size: ${fsXXXXS}px;
  ${fwHeavy};
  letter-spacing: 0.4px;
  text-align: center;
  text-transform: uppercase;
`

interface IProps {
  targetScrollElementRef: React.RefObject<HTMLElement>
}

const ScrollDownIcon: React.FC<IProps> = ({ targetScrollElementRef }) => {
  const onClick = scrollToTarget(targetScrollElementRef)
  const { t } = useTranslation()

  return (
    <StyledScrollDownButton data-testid="ScrollDownButton" onClick={onClick}>
      <Icon size={IconSize.M} asset={IconName.IcScrollWhite} />
      <ScrollText>{t('SCROLL DOWN')}</ScrollText>
    </StyledScrollDownButton>
  )
}

const scrollToTarget = (targetScrollElementRef: React.RefObject<HTMLElement>) =>
  React.useCallback(() => {
    if (targetScrollElementRef.current) {
      const supportsNativeSmoothScroll =
        'scrollBehavior' in document.documentElement.style

      supportsNativeSmoothScroll
        ? window.scrollTo({
            top: targetScrollElementRef.current.offsetTop,
            behavior: 'smooth',
          })
        : window.scrollTo(0, targetScrollElementRef.current.offsetTop)
    }
  }, [targetScrollElementRef])

export default ScrollDownIcon
